import { isValidDate } from "./isValidDate";
import { toStartOfDay } from "./toStartOfDay";

/** Returns the start of the day in the given timezone as a UTC ISO string, or undefined when the date is missing or invalid. */
export const toStartOfDayISO = (date: string | Date | undefined | null, timeZone: string): string | undefined =>
  isValidDate(date) ? toStartOfDay(new Date(date), timeZone).toISOString() : undefined;
